import { createId, titleFromPrompt } from '@/features/chat/chatIds'
import { createThread, updateThreadTitle } from '@/services/chat/threadsApi'
import { resolveSendThreadId } from '../../resolveSendThreadId'

function renameProvisional(threadId, trimmed, setThreads) {
  const title = titleFromPrompt(trimmed)
  setThreads((prev) => prev.map((t) => (t.id === threadId ? { ...t, title } : t)))
  void updateThreadTitle(threadId, title).catch(() => {})
}

/** @param {{ currentId: string | null, forceNewThread: boolean, validIds: string[], setThreads: Function, setActiveThreadId: Function, trimmed: string, files?: unknown[], activeProjectId?: string | null }} p */
export function ensureSendThreadId(p) {
  const { currentId, forceNewThread, validIds, setThreads, setActiveThreadId, trimmed, files, activeProjectId, provisionalId } = p
  // A chat an attachment already created. It is trusted rather than checked
  // against `validIds`, which can be stale if the rail has not re-rendered —
  // and a stale check would mint a second thread for a chat that already holds
  // the uploaded file. Selecting it here is what finally shows it: uploading
  // deliberately does not, because that would remount the composer mid-upload.
  if (provisionalId && !forceNewThread) {
    setActiveThreadId(provisionalId)
    // It was named after the attached file. Its first real prompt is a better
    // title, and this only ever runs once — the composer hands a provisional
    // chat over exactly once.
    if (trimmed) renameProvisional(provisionalId, trimmed, setThreads)
    return provisionalId
  }
  const { existingId, shouldCreate } = resolveSendThreadId({
    currentId,
    forceNewThread,
    validIds,
  })
  let threadId = existingId
  if (shouldCreate) {
    threadId = createId()
    const title = titleFromPrompt(trimmed || (files?.[0]?.name ?? 'Attachment'))
    setThreads((prev) => [{ id: threadId, title, projectId: activeProjectId ?? null }, ...prev])
    setActiveThreadId(threadId)
    void createThread({ id: threadId, title, projectId: activeProjectId }).catch(() => {})
  }
  return threadId
}
